import styled from 'styled-components';
import { WarningBanner } from 'ui/banner';
import { DatePickerInput, SingleDateCalendar } from 'ui/datePicker';
import { colors, spacing, mediumShadow } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const LeftPaddedContainer = styled.div`
  padding-left: ${pxToRem(26)};
`;

export const SpacedDatePicker = styled(DatePickerInput)`
  margin-left: ${pxToRem(24)};
  max-width: ${pxToRem(280)};
  padding-left: ${pxToRem(26)};
`;

export const SpacedWarningBanner = styled(WarningBanner)`
  margin-top: ${spacing.half};
`;

export const StyledSingleDateCalendar = styled(SingleDateCalendar)`
  background-color: ${colors.white};
  padding: ${spacing.quarter};
  width: max-content;
  ${mediumShadow}
`;
